import SwitchSymphony from "elements/SwitchSymphony";
import useWebsite from "Hooks/useWebsite";
import InputSymphony from "elements/InputSymphony";
import CardSymphony from "elements/CardSymphony";

const TitleSetupView = (): JSX.Element => {
    const {
        titleText,
        subtitle,
        showSecondaryLine,
        setTitleText,
        setSubtitle,
        setShowSecondaryLine
    } = useWebsite();

    return (
        <CardSymphony
            className="titleSetupView"
            title='Title'
            size="small"
        >
            <InputSymphony
                className='titleInput'
                value={titleText ?? ''}
                placeholder='Title'
                onChange={(valueText) => setTitleText(valueText || undefined)}
            />
            <SwitchSymphony
                className="secondaryLineSwitch"
                checked={showSecondaryLine}
                onChange={() => setShowSecondaryLine(!showSecondaryLine)}
                label="Add secondary line"
            />
            {showSecondaryLine && (
                <InputSymphony
                    className="secondaryLineInput"
                    value={subtitle ?? ''}
                    placeholder='Secondary line'
                    onChange={(valueText) => setSubtitle(valueText || undefined)}
                />
            )}
        </CardSymphony>
    );
};

export default TitleSetupView;